	<h3 id="header" class="ui primary header">
			{{ modal.context.title }}
			<i class="link times icon" (click)="modal.deny(undefined)"></i>
		</h3>

		<div class="content">
        <div class="ui basic segment" id="fields-container">
                <div  class="ui grid">
					<div class="sixteen wide column text-center" >
						<h3 class="ui primary header"> Select component </h3>
					</div>
                <div class="eight wide column"  *ngFor="let field of fields" >
                    <div   class="ui segment field link"  fxLayout="row" fxLayoutAlign="space-between center"  (click)="modal.approve(field)">
                        <img fxFlex="25%" [src]="field.icon" />
                            <div fxFlex="grow" class="right aligned">{{field?.label}}</div>
                    </div>
                </div>
                </div>
        </div>

			</div>